import { isFunction, isObject, isArray } from '../common/mod.js';
import { http } from '../net/mod.js';
function toAppConfig_(unfault, first, second) {
    if (isFunction(unfault)) {
        return unfault(second ?? first);
    }
    else if (isArray(unfault)) {
        return (isArray(second) ? second : undefined) ?? (isArray(first) ? first : undefined) ?? unfault;
    }
    else if (isObject(unfault)) {
        const map = {};
        for (const key in unfault) {
            map[key] = toAppConfig_(unfault[key], isObject(first) ? first[key] : undefined, isObject(second) ? second[key] : undefined);
        }
        return map;
    }
    return second ?? first ?? unfault;
}
export function toAppConfig(external, defaults, mode = 'production') {
    const modeConfig = mode !== 'production' && external?.deployModeMap ? external.deployModeMap[mode] : undefined;
    const appConfig = toAppConfig_(defaults, external || undefined, modeConfig);
    appConfig.deployMode = mode;
    return appConfig;
}
export async function loadConfig(url, defaults, mode) {
    let external;
    try {
        external = await http.get(url);
    }
    catch {
        console.warn('No se pudo obtener la configuración de aplicación. Se utilizarán los valores por defecto');
    }
    return toAppConfig(external, defaults, mode);
}
//# sourceMappingURL=app_config.js.map